/** @format */

import React, { useEffect, useState } from 'react';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import { InvoiceDataInterface } from '../../../interfaces/platform/InvoiceDataInterface';
import AddButton from '../../../components/Buttons/AddButton';
import CustomInput from '../../../components/CustomInput/CustomInputExt';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import CustomAmountInput from '../../../components/CustomInput/CustomAmountInput';
import { VatCollectionInterface } from '../../../interfaces/collections/VatCollectionInterface';
import InvoiceVat from './InvoiceVat';
import VatInterface from '../../../interfaces/platform/VatInterface';

export type InvoiceDataListProps = {
    listKey: string;
    readonly: boolean;
    header: string;
    vats: VatCollectionInterface;
    headerCallback?: () => void;
    headerCallbackTitle?: string;
    invoiceData?: Array<InvoiceDataInterface>;
    updateItem?: (index: number, column: string, e?: React.ChangeEvent<HTMLInputElement>, type?: string, value?: string) => void;
    deleteCallback?: (data: any) => void;
    correctionInvoice: boolean;
};

const _ = require('underscore');

export const InvoiceDataList = (props: InvoiceDataListProps): React.ReactElement => {
    const propsInvoiceData = props.invoiceData;
    const [invoiceData, setInvoiceData] = useState<Array<InvoiceDataInterface>>([]);
    const [selectedVat, setSelectedVat] = useState<VatInterface>();

    useEffect(() => {
        if (propsInvoiceData) {
            setInvoiceData([...propsInvoiceData]);
        }
    }, [propsInvoiceData]);

    return (
        <>
            <CardHeader
                trans={props.header}
                additionalContent={
                    props.headerCallback && <AddButton tooltipTitle={props.headerCallbackTitle} callback={props.headerCallback} callbackParam={{}} />
                }
            />

            <CardBody>
                {invoiceData &&
                    invoiceData.map((item: InvoiceDataInterface, index: number) => {
                        return (
                            <div key={props.listKey + '_invoice_data_' + index}>
                                <GridContainer>
                                    <GridItem xs={props.deleteCallback ? 4 : 5}>
                                        <CustomInput
                                            labelText={'documents:invoices.record_name'}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            disabled={!props.updateItem}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                                                if (props.updateItem) {
                                                    props.updateItem(index, 'recordName', e);
                                                }

                                                return;
                                            }}
                                            value={item.recordName}
                                            required={true}
                                            inputProps={{}}
                                        />
                                    </GridItem>
                                    <GridItem xs={props.deleteCallback ? 2 : 2}>
                                        <CustomAmountInput
                                            labelText={'documents:invoices.no_tax_amount'}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            inputProps={{}}
                                            required={true}
                                            disabled={!props.updateItem}
                                            allowedDecimalPlaces={2}
                                            valueChange={(value: string): void => {
                                                if (props.updateItem) {
                                                    props.updateItem(index, 'noTaxAmount', undefined, 'number', value);
                                                }

                                                return;
                                            }}
                                            value={String(item.noTaxAmount) || '0.0'}
                                        />
                                    </GridItem>
                                    <GridItem xs={props.deleteCallback ? 1 : 1}>
                                        {/*{props.readonly &&*/}
                                        {/*    <CustomInput*/}
                                        {/*        labelText={'documents:invoices.tax_percentage'}*/}
                                        {/*        formControlProps={{*/}
                                        {/*            fullWidth: true,*/}
                                        {/*        }}*/}
                                        {/*        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {*/}
                                        {/*            if (props.updateItem) {*/}
                                        {/*                props.updateItem(index, 'taxPercentage', e, 'number');*/}
                                        {/*            }*/}

                                        {/*            return;*/}
                                        {/*        }}*/}
                                        {/*        value={item.taxPercentage === -1 ? 0.0 : item.taxPercentage}*/}
                                        {/*        required={true}*/}
                                        {/*        inputProps={{}}*/}
                                        {/*    />*/}
                                        {/*}*/}
                                        {/*{!props.readonly &&*/}
                                        <InvoiceVat
                                            vat={item.vat}
                                            vats={props.vats}
                                            disabled={props.readonly || props.correctionInvoice}
                                            changeVatCallback={(e: React.ChangeEvent<HTMLSelectElement>): void => {
                                                if (!props.updateItem) {
                                                    return;
                                                }
                                                props.updateItem(index, 'vat', undefined, 'string', e.target.value);
                                            }}
                                        />
                                        {/*}*/}
                                    </GridItem>
                                    <GridItem xs={props.deleteCallback ? 2 : 2}>
                                        <CustomAmountInput
                                            labelText={'documents:invoices.tax_amount'}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            inputProps={{}}
                                            required={true}
                                            disabled={!props.updateItem}
                                            allowedDecimalPlaces={2}
                                            valueChange={(value: string): void => {
                                                if (props.updateItem) {
                                                    props.updateItem(index, 'taxAmount', undefined, 'number', value);
                                                }

                                                return;
                                            }}
                                            value={String(item.taxAmount) || '0.0'}
                                        />
                                    </GridItem>
                                    <GridItem xs={props.deleteCallback ? 2 : 2}>
                                        <CustomAmountInput
                                            labelText={'documents:invoices.taxed_amount'}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            inputProps={{}}
                                            required={true}
                                            disabled={!props.updateItem}
                                            allowedDecimalPlaces={2}
                                            valueChange={(value: string): void => {
                                                if (props.updateItem) {
                                                    props.updateItem(index, 'amount', undefined, 'number', value);
                                                }

                                                return;
                                            }}
                                            value={String(item.amount) || '0.0'}
                                        />
                                    </GridItem>
                                    {props.deleteCallback && (
                                        <GridItem xs={1}>
                                            <DeleteButton
                                                callback={props.deleteCallback}
                                                callbackParam={{ item: item, index: index }}
                                                tooltipTitle={'documents:invoices.remove_line'}
                                            />
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </div>
                        );
                    })}
            </CardBody>
        </>
    );
};

export default InvoiceDataList;
